module.exports = __webpack_public_path__ + "static/media/cardIconDone.19e22401.svg";